import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import websocketService from '../services/websocketService';

interface NewPostData {
  postId: string;
  title: string;
  authorId: string;
  authorName: string;
  message: string;
}

interface NotificationData {
  id: string;
  type: string;
  message: string;
  isRead: boolean;
  createdAt: string;
}

export const useWebSocket = () => {
  const { user } = useAuth();
  const connectAttempted = useRef(false);

  useEffect(() => {
    if (user?.id && !connectAttempted.current) {
      websocketService.connect(user.id);
      connectAttempted.current = true;
    }

    return () => {
      if (!user?.id) {
        websocketService.disconnect();
        connectAttempted.current = false;
      }
    };
  }, [user?.id]);

  const onNewPost = (callback: (data: NewPostData) => void) => {
    websocketService.on('newPost', callback);
    return () => websocketService.off('newPost', callback);
  };

  const onNewNotification = (callback: (data: NotificationData) => void) => {
    websocketService.on('newNotification', callback);
    return () => websocketService.off('newNotification', callback);
  };

  const isConnected = () => {
    return websocketService.isConnected();
  };

  return {
    onNewPost,
    onNewNotification,
    isConnected
  };
};